﻿<template>

    <div class="ts-pills">
        <p v-if="getFilterMessage(getTags()) != ''" class="ts-pills-title">{{getFilterMessage(getTags())}}</p>
        <ul class="ts-pill-list">
            <li v-for="tag in getTags()" :key="tag.name">
                <button type="button" class="ts-pill" :class="{ 'is-active': tag_Selected(tag) }" :aria-pressed="tag_Selected(tag)" @click="toggleTag(tag)">
                    <svg v-if="tag_Selected(tag)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5" /></svg>
                    {{tag.name}}
                </button>
            </li>
        </ul>
    </div>

</template>

<script lang="ts" src="./filter_buttons.ts"></script>